import React from 'react'
import * as Sentry from '@sentry/browser'
import { t } from 'ttag'

const PRODUCTION = process.env.PRODUCTION

const ErrorMessage = ({ errorInfo, error }) => (
  <div
    style={{
      color: 'white',
      background: 'red',
      padding: '10px',
    }}
  >
    <h2>
      {t`Error`}: {error.toString()}
    </h2>
    {PRODUCTION ? (
      <button onClick={() => Sentry.showReportDialog()}>
        {t`Report error?`}
      </button>
    ) : (
      <pre
        style={{
          background: 'white',
          color: 'black',
          maxHeight: '200px',
          fontSize: '12px',
          overflow: 'auto',
        }}
      >
        {errorInfo.componentStack}
      </pre>
    )}
  </div>
)

export class SentryErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo })
    if (PRODUCTION)
      Sentry.withScope(scope => {
        Object.keys(errorInfo).forEach(key => {
          scope.setExtra(key, errorInfo[key])
        })
        Sentry.captureException(error)
      })
  }

  render() {
    return this.state.error ? (
      <ErrorMessage {...this.state} />
    ) : (
      this.props.children
    )
  }
}
